module.exports = __webpack_public_path__ + "img/k-news-icon.66f42398.png";